/**
 * 各種効果音の処理
 */
class SoundEffect {
  /**
   * 
   * @param {Object} rlsnd ルーレット作動中音のAudioオブジェクト
   * @param {Object} stsnd ルーレット停止音のAudioオブジェクト
   * @param {Object} ppsnd ポップアップ音のAudioオブジェクト
   * @param {Object} bgm BGM音のAudioオブジェクト
   */
  constructor(rlsnd, stsnd, ppsnd, bgm) {
    this.rouletteSounds = rlsnd || null
    this.rouletteStopSounds = stsnd || null
    this.popupSounds = ppsnd || null
    this.bgm = bgm || null
  }
  /**
   * ルーレット作動中の効果音を再生
   */
  playRouletteSound () {
    //console.log('rouletteSounds.play()')
    this.rouletteSounds.load()
    this.rouletteSounds.play()
  }
  /**
   * ルーレット作動中の効果音を停止
   */
  stopRouletteSound () {
    if (this.rouletteSounds != null) {
      //console.log('rouletteSounds.pause()')
      this.rouletteSounds.pause()
    }
  }
  /**
   * ルーレット停止の効果音を再生
   */
  playStopSound () {
    //console.log('rouletteStopSounds.play()')
    this.rouletteStopSounds.play()
  }

  /**
   * ポップアップアラート表示時の効果音を再生
   */
  playPopupSound () {
    //console.log('popupSounds.play()')
    this.popupSounds.play()
  }
  /**
   * ルーレット停止効果音オブジェクトをクリア
   */
  clearRouletteStopSounds () {
    //console.log('rouletteStopSounds')
    this.rouletteStopSounds = null
  }
  /**
   * BGMを再生
   */
  playBgmSound () {
    this.bgm.play()
    this.bgm.loop = true
  }
  /**
   * BGMを停止
   */
  stopBgmSound () {
    this.bgm.pause()
  }
}

export default SoundEffect
